/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MonitorResult } from '../models/MonitorResult';
import type { RpcHealthCheckInfo } from '../models/RpcHealthCheckInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MonitorControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns MonitorResult OK
     * @throws ApiError
     */
    public postRpcHealthChecker(): CancelablePromise<MonitorResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/rpc/check',
        });
    }

    /**
     * @returns RpcHealthCheckInfo OK
     * @throws ApiError
     */
    public getRpcHealthChecker(): CancelablePromise<RpcHealthCheckInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rpc/check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/l7check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check3(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/l7check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check2(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/l7check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check5(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/l7check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check6(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/l7check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check1(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'HEAD',
            url: '/l7check',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public l7Check4(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/l7check',
        });
    }

}
